import React, { Component } from "react"

// import config from "react-global-configuration"
import * as cookieHelper from "../../helpers/cookie"

import * as endpoint from "../constants/Endpoints"
import LoginLink from "./common/loginLink"

import { UserProfile } from "../../hooks/userProfile"

class LoginState extends Component {
  render() {
    const { config } = this.props
    const textKeys = config && config.textKeys ? config.textKeys : {}
    console.log(config)
    return (
      <UserProfile>
        {(profile) => {
          if (profile !== null && profile.ContactDetails) {
            return (
              <a className={textKeys.linkClassName || (!textKeys.isShop && "button button--nav")} href={textKeys.myAdvantageLink}>
                <span className="text name">{textKeys.cphProfileLabel}</span>
              </a>
            )
          } else if (cookieHelper.isLoggedIn()) {
            return (
              <LoginLink
                loginurl={endpoint.ACCOUNT_LOGIN(config && config.hosts, config && config.language)}
                linkClassName={textKeys.linkClassName || "button button--nav"}
                spanClassName={"text name"}
                linkText={textKeys.myAdvantageLabel}
                isShop={textKeys.isShop}
                trackingHandler={textKeys.trackingHandler}
              />
            )
          } else {
            return (
              <LoginLink
                loginurl={endpoint.ACCOUNT_LOGIN(config && config.hosts, config && config.language)}
                linkClassName={textKeys.linkClassName || "button button--nav"}
                spanClassName={"text"}
                linkText={textKeys.loginLabel}
                isShop={textKeys.isShop}
                trackingHandler={textKeys.trackingHandler}
              />
            )
          }
        }}
      </UserProfile>
    )
  }
}

export default LoginState
